export enum UserRole {
  REOPS_ADMIN = 'ReOps Admin',
  SELLER_ADMIN = 'Seller Admin',
  SELLER_DEV = 'Seller Developer',
}

export const UserRoleById: { [key: string]: string } = {
  '344c493c': 'ReOps Admin',
  '6e12fbae': 'Seller Admin',
  [`f6f0e789`]: 'Seller Developer',
};

export enum UserStatus {
  INVITED = 'Invited',
  SUSPENDED = 'Suspended',
  UNSUSPENDED = 'Unsuspended',
}

export enum UserPermissions {}

export const acceptableRolesForApp = [
  UserRole.REOPS_ADMIN,
  UserRole.SELLER_ADMIN,
  UserRole.SELLER_DEV,
];

export const rolesPermittedToModifySeller = [
  UserRole.REOPS_ADMIN,
  UserRole.SELLER_ADMIN,
];
